"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./PropertiesService");

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _ActionTypes = require("../actions/ActionTypes");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _LazyKeyStore = require("../store/LazyKeyStore");

var ObjectTypes = _interopRequireWildcard(require("customer-data-objects/constants/ObjectTypes"));

var PropertiesStore = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: _ActionNamespaces.PROPERTIES,
  idIsValid: function idIsValid(objectType) {
    return Object.prototype.hasOwnProperty.call(ObjectTypes, objectType);
  },
  responseTransform: (0, _getIn.default)(['properties'])
}).defineName('PropertiesStore').defineResponseTo([_ActionTypes.PROPERTIES_CREATE_STARTED, _ActionTypes.PROPERTIES_CREATE_SUCCEEDED], function (state, _ref) {
  var objectType = _ref.objectType,
      property = _ref.property;
  return state.setIn([objectType, property.name], property);
}).defineResponseTo(_ActionTypes.PROPERTIES_CREATE_FAILED, function (state, _ref2) {
  var objectType = _ref2.objectType,
      property = _ref2.property;
  return state.deleteIn([objectType, property.name]);
}).register(_dispatcher.default);
var _default = PropertiesStore;
exports.default = _default;
module.exports = exports.default;